import '@styles/ProductOperation/style.css'
import React from 'react'
import ProductMedia, { IProductMedia } from '../ProductMedia'
import classNames from 'classnames'

export interface ProductOperationProps extends IProductMedia {
  bottomLeftIcon?: any
  bottomRightIcon?: any
  topLeftIcon?: any
  topRightIcon?: any
  bottomVideoIcon?: any
  containerClass?: any
  showCrossLine?: boolean
}

export const ProductOperation: React.FC<ProductOperationProps> = ({
  bottomLeftIcon,
  bottomRightIcon,
  topLeftIcon,
  topRightIcon,
  bottomVideoIcon,
  containerClass,
  showCrossLine,
  ...props
}) => {
  return (
    <div
      className={classNames(
        'product-operation-container',
        'crossed-mark',
        containerClass
      )}
    >
      {showCrossLine ? (
        <div className='drawlineoverit' onClick={props.onClick}></div>
      ) : null}
      <div
        className={classNames('product-media-section', {
          'inactive-product-image': showCrossLine
        })}
      >
        <ProductMedia {...props} />
      </div>
      {bottomLeftIcon && (
        <div className={'product-operation-icon-bottom-left'}>{bottomLeftIcon}</div>
      )}
      {bottomVideoIcon && (
        <div
          className={
            bottomLeftIcon
              ? 'product-operation-video-icon'
              : 'product-operation-icon-bottom-left'
          }
        >
          {bottomVideoIcon}
        </div>
      )}
      {bottomRightIcon && (
        <div className={'product-operation-icon-bottom-right'}>{bottomRightIcon}</div>
      )}
      {topLeftIcon && (
        <div className={'product-operation-icon-top-left'}>{topLeftIcon}</div>
      )}
      {topRightIcon && (
        <div className={'product-operation-icon-top-right'}>{topRightIcon}</div>
      )}
    </div>
  )
}
